import wd from '../images/wd.png';
import ws from '../images/ws.png';
import ai from '../images/ai.png';
import ui from '../images/ui.png';
import {ImCircleRight} from 'react-icons/im';





export const ServiceData = [


    {
        id : 1,
        icon: ui,
        service_title_1 :'ui/ux',
        service_title_2 :'Design',
        service_model_description :"I strive to design interfaces and experiences that people can enjoy on all digital mediums. Providing quality work to clients.",
        lIcon_1 :<ImCircleRight/>,
        li_1 : 'I develop the user interface.',
        lIcon_2 :<ImCircleRight/>,
        li_2 : 'Design and mockups of products for companies.',
        lIcon_3 :<ImCircleRight/>,
        li_3 : 'I create ux element interactions.',
        lIcon_4 :<ImCircleRight/>,
        li_4 : 'I position your company brand.',
        lIcon_5 :<ImCircleRight/>,
        li_5 : 'Provide Quality works.',
    },
    {
        id : 2,
        icon: wd,
        service_title_1 :'Web',
        service_title_2 :'Dev',
        service_model_description :'I try to write clean, readable code that can be used in multiple way to create beautiful applications. Providing quality work to clients.',
        lIcon_1 :<ImCircleRight/>,
        li_1 : 'I develop the Backend.',
        lIcon_2 :<ImCircleRight/>,
        li_2 : 'Single-page and Multi-page Web application.',
        lIcon_3 :<ImCircleRight/>,
        li_3 : 'Modern technologies are used.',
        lIcon_4 :<ImCircleRight/>,
        li_4 : 'I position your company brand.',
        lIcon_5 :<ImCircleRight/>,
        li_5 : 'Provide Quality Works.',
    },
    {
        id : 3,
        icon: ai,
        service_title_1 :'AI & ML',
        service_title_2 :'Project',
        service_model_description :'I discovered project management by merging human ingenuity with AI advancements that have proven to support project success.',
        lIcon_1 :<ImCircleRight/>,
        li_1 : 'AI model based Website.',
        lIcon_2 :<ImCircleRight/>,
        li_2 : 'AI & ML model development.',
        lIcon_3 :<ImCircleRight/>,
        li_3 : 'Business Ideas.',
        lIcon_4 :<ImCircleRight/>,
        li_4 : 'Data Analysis.',
        lIcon_5 :<ImCircleRight/>,
        li_5 : 'Provide Quality works.',
    },
    {
        id : 4,
        icon: ws,
        service_title_1 :'Web',
        service_title_2 :'Support',
        service_model_description :'Provide all kinds of website maintenance and support services you require to ensure both the short and long term success of your business.',
        lIcon_1 :<ImCircleRight/>,
        li_1 : 'ui/ux quality Improvement.',
        lIcon_2 :<ImCircleRight/>,
        li_2 : 'Backend & DB Problems.',
        lIcon_3 :<ImCircleRight/>,
        li_3 : 'Stack Switch and Upgrade.',
        lIcon_4 :<ImCircleRight/>,
        li_4 : 'Hosting Problems.',
        lIcon_5 :<ImCircleRight/>,
        li_5 : 'Provide Quality works.',
    },



];

